export const horizontalCurveData = [
	{
		label: 'Horizontal',
		data: [
		{
			x: 0,
			y: 5,
		},
		{
			x: 1,
			y: 5,
		},
		{
			x: 2,
			y: 5,
		},

		{
			x: 3,
			y: 5,
		},

		{
			x: 4,
			y: 5,
		},

		{
			x: 5,
			y: 5,
		},

		{
			x: 6,
			y: 5,
		},
		],
	}	
]

export const linearCurveData = [
	{
		label: 'Linear',
		data: [
			{
				x: 0,
				y: 1,
			},
			{
				x: 1,
				y: 2,
			},
			{
				x: 2,
				y: 3,
			},

			{
				x: 3,
				y: 4,
			},

			{
				x: 4,
				y: 5,
			},

			{
				x: 5,
				y: 6,
			},

			{
				x: 6,
				y: 7,
			},
		],
	}	
]

export const quadraticCurveData = [
	{
		label: 'Quadratic',
		data: [
			{
				x: 0,
				y: 1,
			},
			{
				x: 1,
				y: 4,
			},
			{
				x: 2,
				y: 9,
			},
			{
				x: 3,
				y: 16,
			},
			{
				x: 4,
				y: 25,
			},
			{
				x: 5,
				y: 36,
			},
			{
				x: 6,
				y: 49,
			},
		],
	}	
]

export const sigmoidCurveData = [
	{
		label: 'Sigmoid',
		data: [
			{
				x: 0,
				y: 1.75,
			},
			{
				x: 1,
				y: 2.54,
			},
			{
				x: 2,
				y: 3.96,
			},
			{
				x: 3,
				y: 6.63,
			},
			{
				x: 4,
				y: 11.97,
			},
			{
				x: 5,
				y: 20,
			},
			{
				x: 6,
				y: 28.23,
			},
			{
				x: 7,
				y: 33.37,
			},
			{
				x: 8,
				y: 36.055,
			},
			{
				x: 9,
				y: 37.47,
			},
			{
				x: 10,
				y: 38.25,
			},
		],
	}	
]